import { render, staticRenderFns } from "./ContentCarousel.html?vue&type=template&id=20b9853d&scoped=true&shadow"
import script from "./ContentCarousel.ts?vue&type=script&lang=ts&shadow"
export * from "./ContentCarousel.ts?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentCarousel.scss?vue&type=style&index=0&id=20b9853d&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "20b9853d",
  null
  ,true
)

export default component.exports